/**
 * Pre-Arrival Checklist
 * Preparation before arrival at destination
 * Regulatory: Company SMS
 */

export const PRE_ARRIVAL_CHECKLIST = {
  id: 'pre_arrival',
  name: 'Pre-Arrival',
  description: 'Preparation before arrival at destination',
  icon: 'MapPin',
  regulatory: 'Company SMS',
  isCustomisable: true,
  items: [
    { id: 'pa_1', text: 'ETA notified to destination/agent', required: true },
    { id: 'pa_2', text: 'Berth/anchorage information confirmed', required: true },
    { id: 'pa_3', text: 'Pilot requirements confirmed (if applicable)', required: false },
    { id: 'pa_4', text: 'Mooring plan reviewed', required: true },
    { id: 'pa_5', text: 'Crew briefed on arrival duties', required: true },
    { id: 'pa_6', text: 'Fenders and lines prepared', required: true }
  ]
};
